import {Singleton} from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';

import EntityAware from '../entity/EntityAware';
import NamaItemPembayaran from "../entity/NamaItemPembayaran";
import {Serialize} from "cerialize";
import Parameter from "./Parameter";

@Singleton
export default class ItemPembayaranService extends ProxyService {

    public api: string = environment.ITEM_PEMBAYARAN_API;   // define api url to fetch data

    public serializer: EntityAware = NamaItemPembayaran;

    public downloadTemplate() {
        const api: string = this.api + `/template`;
        const fileName = `Template Item Pembayaran.xlsx`;
        return super.downloadFile(api, fileName, false);
    }

    public upload(T: NamaItemPembayaran) {
        const param: FormData = new FormData();
        const api = this.api + '/upload';

        param.append('file', T.file);
        param.append("payload", JSON.stringify(Serialize(T)));

        const parameter: Parameter = new Parameter(param).setUrl(api).setMethod(Parameter.methods.POST).setEnableNotif(false);

        return super.request(parameter);
    }

}
